import React from 'react';
import {
  Modal,
  Input,
  Row,
  Col,
  Upload,
  message,
  Icon,
  Spin,
  Tooltip
} from 'antd';
const { TextArea } = Input;

class AddActivity extends React.Component {
  state = {
    activity: '',
    notes: '',
    uploads: [],
    uploaded: []
  };

  componentDidUpdate = prevProps => {
    if (
      this.props.editing &&
      this.props.open &&
      (prevProps.open !== this.props.open ||
        prevProps.editing !== this.props.editing)
    ) {
      const { editing } = this.props;
      this.setState({
        uploaded: editing.downloadURL,
        notes: editing.notes,
        activity: editing.title
      });
    }
  };

  addUpload = upload => {
    let { uploads } = this.state;
    uploads.push(upload.file);
    this.setState({ uploads });
  };

  cancelUpload = upload => {
    let { uploads } = this.state;
    uploads = uploads.filter(item => item !== upload);
    this.setState({ uploads });
  };

  closeModal = () => {
    this.setState({
      activity: '',
      notes: '',
      uploads: [],
      uploaded: []
    });
    this.props.close();
  };

  submitModal = () => {
    const { t } = this.props;
    if (
      this.state.activity == '' ||
      (this.state.uploads.length == 0 && this.state.uploaded.length == 0) ||
      this.state.notes == ''
    ) {
      return message.error(t('All fields are mandatory!'));
    } else {
      this.props.addActivity(this.state);
      this.setState({
        activity: '',
        notes: '',
        uploads: [],
        uploaded: []
      });
    }
  };

  render() {
    const { t, color } = this.props;
    const styles = {
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        alignSelf: 'left'
      },
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      uploadBtn: {
        fontSize: 20,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: '0 2px 3px 0 rgba(0,0,0,0.5)'
      }
    };

    return (
      <Modal
        visible={this.props.open}
        onCancel={() => this.closeModal()}
        footer={false}
        width={635}>
        <h3
          style={{
            marginBottom: 0,
            fontSize: 20,
            fontFamily: 'Arial Rounded MT Bold',
            color: color,
            alignSelf: 'left'
          }}>
          {this.props.editing ? t('Edit Action') : t('Create Action')}
        </h3>
        <div style={styles.titleDiv}>
          <h3 style={styles.title}>{t('Title Activity')}</h3>
          <Tooltip title="Write the name of the activity">
            <img style={{ height: 16, width: 16 }} src={this.props.icon} />
          </Tooltip>
        </div>
        <TextArea
          rows={2}
          onChange={e => this.setState({ activity: e.target.value })}
          style={{
            marginTop: 10,
            border: `1px solid ${color}`,
            fontSize: 16
          }}
          value={this.state.activity}
        />

        <div style={styles.titleDiv}>
          <h3 style={styles.title}>{t('Notes')}</h3>
          <Tooltip title="Give a description of what you were doing, including any questions you might have or reminders on what you need to do next.">
            <img style={{ height: 16, width: 16 }} src={this.props.icon} />
          </Tooltip>
        </div>
        <TextArea
          rows={3}
          onChange={e => this.setState({ notes: e.target.value })}
          style={{
            marginTop: 10,
            border: `1px solid ${color}`,
            fontSize: 16
          }}
          value={this.state.notes}
        />

        <div style={styles.titleDiv}>
          <div>
            <h3 style={styles.title}>{t('Upload File')}</h3>
            <p
              style={{
                fontFamily: 'Helvetica Neue',
                fontSize: 12,
                margin: 0,
                color: color
              }}>
              {t('(Maximum 5 attachments)')}
            </p>
          </div>
          <Upload
            disabled={this.state.uploads.length == 5}
            customRequest={this.addUpload}
            showUploadList={false}>
            <div style={styles.uploadBtn}>+</div>
          </Upload>
        </div>

        {this.state.uploaded &&
          this.state.uploaded.map((item, index) => (
            <div
              style={{
                borderRadius: 20,
                backgroundColor: color,
                fontSize: 14,
                color: 'white',
                padding: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 10
              }}>
              <span>{t(item.name)}</span>
              <span
                onClick={() => this.props.deleteFile(item.url, index)}
                style={{
                  float: 'right',
                  width: 20,
                  textAlign: 'right',
                  cursor: 'pointer'
                }}>
                X
              </span>
            </div>
          ))}

        {this.state.uploads &&
          this.state.uploads.map(item => (
            <div
              style={{
                borderRadius: 20,
                backgroundColor: color,
                fontSize: 14,
                color: 'white',
                padding: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 10
              }}>
              <span>{t(item.name)}</span>
              <span
                onClick={() => this.cancelUpload(item)}
                style={{
                  float: 'right',
                  width: 20,
                  textAlign: 'right',
                  cursor: 'pointer'
                }}>
                X
              </span>
            </div>
          ))}

        <Row
          style={{
            height: 45,
            width: '100%',
            marginTop: 20,
            position: 'absolute',
            right: 0,
            bottom: -42
          }}>
          <Col
            xs={12}
            style={{
              backgroundColor: '#F7556B',
              height: 45,
              paddingTop: 9,
              borderBottomLeftRadius: 5,
              cursor: 'pointer'
            }}
            onClick={() => this.closeModal()}>
            <h3
              style={{
                fontSize: 16,
                fontFamily: 'Arial Rounded MT Bold',
                textAlign: 'center',
                color: 'white'
              }}>
              {t('Discard')}
            </h3>
          </Col>
          <Col
            xs={12}
            style={{
              backgroundColor: color,
              height: 45,
              paddingTop: 9,
              borderBottomRightRadius: 5,
              cursor: 'pointer'
            }}
            onClick={() => this.submitModal()}>
            <h3
              style={{
                fontSize: 16,
                fontFamily: 'Arial Rounded MT Bold',
                textAlign: 'center',
                color: 'white'
              }}>
              {t('Submit')}
            </h3>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default AddActivity;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/addActivity.js